import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { Router } from "@angular/router";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { GonedarkcolorPipe, DatetimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleetwide-asset-logins",
	templateUrl: "./fleetwide-asset-logins.component.html",
	styleUrls: ["./fleetwide-asset-logins.component.scss"],
	imports: [GonedarkcolorPipe, DatetimePipe]
})
export class FleetwideAssetLoginsComponent implements OnInit {
	api = inject(ApiService);
	private router = inject(Router);

	@Output()
	public AssetSelected = new EventEmitter<APIResults.Asset>();

	public allAssets: APIResults.Asset[];
	public goneDarkAssets: any[] = [];

	ngOnInit() {
		this.UpdateAssets();
	}

	public async UpdateAssets() {
		let assets = await this.api.GetAllAssets();
		assets = assets.filter(a => a.last_login && a.organization_id !== 1);
		const now = Moment();
		// Attach lateness in days
		for (const asset of assets as LateAsset[]) {
			if (asset.last_login) {
				const darkDays = now.diff(Moment(asset.last_login), "days");
				asset.late_days = darkDays;
			}
		}

		this.goneDarkAssets = assets.sort((a, b) => (a.last_login < b.last_login) ? 1 : -1);
	}

	public async SelectAsset(target: APIResults.Asset) {
		this.AssetSelected.emit(target);
	}
}

interface LateAsset extends APIResults.Asset {
	late_days: number;
}